
import type { PostParams } from 'app/dataTypes/dishes/addToAllOrgs'

import type { Request } from '../../../index'

/**
 * Добавление уже созданных блюд ко всем школам
 */

type ApiParams = {
  item_ids?: Array<number> // id продуктов
  category_title?: string // опционально, default "Прочее"
}

export const convertParams = (params: PostParams): [ApiParams, null] => {
  const { dishIds } = params
  return [{
    item_ids: dishIds ? dishIds.map((id) => parseInt(id, 10)) : [],
  }, null]
}

type ResultApi = 'success'

export const convertResult = (data: ResultApi): 'success' => {
  return data
}

export const POST_FOOD_ITEMS_ADD_TO_ALL_SCHOOLS: Request<PostParams, void, void> = [
  'food/items/add_to_all_schools',
  'post',
  ['data'],
]
